export default __webpack_public_path__ + "static/media/aboutus-3.95096a5c.jpg";